import React, {Component} from 'react';
import moment from 'moment';
import  Text from 'antd/lib/typography/Text';

class TodayTime extends Component {
    constructor(props) {
        super(props)

        this.state = {
            now: moment().format("LLLL")
        }
    }

    render() {
        const {now} = this.state;
        return (
            <Text style={{fontSize:20}} >{now}</Text>
        );
    }

    componentDidMount() {
        // add the interval
        this.interval = setInterval(this.updateReminderTime.bind(this), 10*1000);
    }

    componentWillUnmount() {
        // remove the interval listener
        try{
        clearInterval(this.interval);
        }catch(e){
            console.log("ERROR CLEARING INTERVAL",e)
        }
    }

    updateReminderTime() {
        this.setState({
            now: moment().format("LLLL")
        })
    }

}

export default TodayTime;
